import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from '@app/components/shared/base-modal/base-modal.component';
import { ModalControlsComponent } from '@app/components/shared/modal-controls/modal-controls.component';
import { ConfirmationResult } from '@app/utils/enums/confirmation-result.enum';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [BaseModalComponent, TranslateModule, ModalControlsComponent],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationModalComponent {
  private readonly dialogRef = inject(MatDialogRef<ConfirmationModalComponent>);

  public close(): void {
    this.dialogRef.close(ConfirmationResult.Cancel);
  }

  public terminate(): void {
    this.dialogRef.close(ConfirmationResult.Confirm);
  }
}
